module.exports = __webpack_public_path__ + "img/qatar.e28e9df8.svg";